interface TableDescriptor
{
	column_number: number;
	bordered: boolean;
	striped: boolean;
	hover?: boolean;
	condensed?: boolean;
}

class Table
{
	private table: HTMLTableElement;
	private tbody: any;
	private rowCount: number;

	private col_number: number;

	constructor( descriptor: TableDescriptor )
	{
		this.table = document.createElement( 'table' );
		$( this.table ).addClass( 'table' );

		if ( descriptor.bordered )
		{
			$( this.table ).addClass( 'table-bordered' );
		}

		if ( descriptor.striped )
		{
			$( this.table ).addClass( 'table-striped' );
		}

		if ( descriptor.condensed )
		{
			$( this.table ).addClass( 'table-condensed' );
		}

		if ( descriptor.hover )
		{
			$( this.table ).addClass( 'table-hover' );
		}

		this.tbody = this.table.createTBody();

		this.rowCount = 0;

		this.col_number = descriptor.column_number;
	}

	public getTable() : HTMLTableElement
	{
		return this.table;
	}

	public clear(): void
	{
		$( this.table ).empty();
	}

	public clearBody(): void
	{
		$( this.tbody ).empty();
	}

	public createHeaderRow( index: number, data: Array<string|HTMLElement|JQuery<HTMLElement>> ) : void
	{

		if ( index < -1 || index >= this.rowCount )
		{
			index = -1;
		}

		const row = this.tbody.insertRow( index );

		let k = 0;
		for (; k < this.col_number && k < data.length; ++k )
		{
			// XXX Erzeugt td's mit style: bold; Nach ordentlicher Alternative suchen
			const cell = row.insertCell( -1 );

			$( cell ).attr( 'style', 'font-weight: bold;' );

			$( cell ).append( data[ k ] );
		}

		for (; k < this.col_number; ++k )
		{
			row.insertCell( -1 );
		}

		++this.rowCount;
	}

	public createDataRow( index: number, data: Array<string|HTMLElement|JQuery<HTMLElement>> ) : void
	{
		'use strict';

		if ( index < -1 || index >= this.rowCount )
		{
			index = -1;
		}

		const row = this.tbody.insertRow( index );

		let k = 0;
		for (; k < this.col_number && k < data.length; ++k )
		{
			const cell = row.insertCell( -1 );

			$( cell ).append( data[ k ] );
		}

		for (; k < this.col_number; ++k )
		{
			row.insertCell( -1 );
		}

		++this.rowCount;
	}

	public deleteRow( callerElement: HTMLElement ) : void
	{
		this.table.deleteRow( this.getRowId( callerElement ) );

		--this.rowCount;
	}

	public deleteCell( callerElement: HTMLElement ) : void
	{
		this.deleteCellIndexed( this.getRow( callerElement ), this.getCellId( callerElement ) );
	}

	public deleteCellIndexed( row: HTMLTableRowElement, cell_idx: number ) : void
	{
		row.deleteCell( cell_idx );

		row.insertCell( cell_idx );
	}

	public replaceCell( callerElement: HTMLElement, celldata: string ) : void
	{
		this.replaceCellIndexed( this.getRow( callerElement ), this.getCellId( callerElement ), celldata );
	}

	public replaceCellIndexed( row: HTMLTableRowElement, cell_idx: number, celldata: string ) : void
	{
		row.deleteCell( cell_idx );

		$( row.insertCell( cell_idx ) ).html( celldata );
	}

	private getRowId( node: any ) : number
	{
		return this.getRow( node ).rowIndex;
	}

	private getCellId( node: any ) : number
	{
		return this.getCell( node ).cellIndex;
	}

	private getRow( node: any ) : HTMLTableRowElement
	{
		if ( node.tagName == 'TR' )
		{
			return node;
		}

		return this.getRow( node.parentNode );
	}

	private getCell( node: any ) : HTMLTableCellElement
	{
		if ( node.tagName == 'TD' || node.tagName == 'TH' )
		{
			return node;
		}

		return this.getCell( node.parentNode );
	}
}
